import React from 'react';
import { FaqList } from '@components/FaqList';
import { ColoredBlockSection } from '@sections/shared/ColoredBlockSection';
import { Layout, Seo } from '@layout';
import {
  RegistryHeroSection,
  RegistryCashFreeGiftingSection,
  RegistryPublicCatalogSection,
  RegistryCross,
  UniversalRegistry,
  ChooseExperiencesSection,
} from '@sections/cash-fund-registry';
import { useTranslation } from 'react-i18next';

const PAGE: MarcomPageName = 'cash-fund-registry';

const CashRegistry = () => {
  const { t } = useTranslation();
  const seo = t('seo', { ns: 'cashFundRegistry' });
  const faqQuestionsData = t('questions', { ns: 'faq' });

  const moreTimeTogetherSectionId = 'Bucket_Listing';
  return (
    <Layout
      transparentJoyLogoColor="neutra6"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      isTransparentHeader={true}
      headerScrollThresholdVh={35}
      page={PAGE}
    >
      <Seo
        title={seo.title}
        canonicalURL={'https://withjoy.com/cash-fund-registry/'}
        description={seo.content}
        ogImage={'common/meta_share/registry.jpg'}
      />
      <RegistryHeroSection />
      <RegistryCashFreeGiftingSection />
      <ChooseExperiencesSection />
      <div id={moreTimeTogetherSectionId}>
        <UniversalRegistry />
      </div>
      <RegistryPublicCatalogSection />
      <RegistryCross />
      <ColoredBlockSection
        isLeftAligned
        backgroundColor="white"
        sideHeaderText={t('faq.title', { ns: 'cashFundRegistry' })}
        sectionId="Cash_Registry_Design_FAQ"
        isToggleNeeded={true}
      >
        <FaqList accordion={true} questionNodes={[...faqQuestionsData.cashFundRegistry, ...faqQuestionsData.general]} color="neutra6" />
      </ColoredBlockSection>
    </Layout>
  );
};

export default CashRegistry;
